<!-- HcListPopPage.vue -->
<template>
  <div class="hc-popup-overlay">
    <div class="hc-popup-content" @click.stop>
      <div class="hc-popup-header">
        <h3>매장명: {{ shopData.SHOP_NM }} 근무관리 입력/수정</h3>
        <button @click="closePopup" class="btn-close-header">X</button>
      </div>
      <div class="popup-body">
        <div class="form-grid">
          <!-- 사업주 섹션 -->
          <div class="form-section">
            <h4 class="section-title">사업주</h4>
            <div class="input-row-header owner-header">
              <span class="row-number-header"></span>
              <span class="name-header">이름</span>
              <span class="position-header">직급</span>
              <span class="status-header">근무</span>
            </div>
            <div class="input-row" v-if="owner">
              <span class="row-number">{{ owner.lColNo }}</span>
              <input v-model="owner.sName" placeholder="이름" class="name-input" />
              <select v-model="owner.sPosition">
                <option value="사업주">사업주</option>
              </select>
              <select v-model="owner.sState">
                <option value="근무">근무</option>
                <option value="휴무">휴무</option>
              </select>
            </div>
          </div>

          <!-- 재직직원 섹션 -->
          <div class="form-section">
            <h4 class="section-title">재직직원</h4>
            <div class="input-row-header staff-header">
              <span class="row-number-header"></span>
              <span class="name-header">이름</span>
              <span class="position-header">직급</span>
              <span class="status-header">근무</span>
            </div>
            <div
              v-for="employee in staff"
              :key="employee.lColNo"
              class="input-row"
            >
              <span class="row-number">{{ employee.lColNo - 1 }}</span>
              <input v-model="employee.sName" placeholder="이름" class="name-input" />
              <select v-model="employee.sPosition">
                <option value="">직급선택</option>
                <option value="차장">차장</option>
                <option value="과장">과장</option>
                <option value="대리">대리</option>
                <option value="주임">주임</option>
                <option value="기사">기사</option>
              </select>
              <select v-model="employee.sState">
                <option value="근무">근무</option>
                <option value="휴무">휴무</option>
                <option value="파견간직원">파견간직원</option>
              </select>
            </div>
          </div>

          <!-- 파견온직원 섹션 -->
          <div class="form-section">
            <h4 class="section-title">파견온직원</h4>
            <div class="input-row-header dispatched-header">
              <span class="row-number-header"></span>
              <span class="name-header">이름</span>
              <span class="position-header">직급</span>
              <span class="status-header">근무</span>
            </div>
            <div
              v-for="employee in dispatchedStaff"
              :key="employee.lColNo"
              class="input-row"
            >
              <span class="row-number">{{ employee.lColNo - 8 }}</span>
              <input v-model="employee.sName" placeholder="이름" class="name-input" />
              <select v-model="employee.sPosition">
                <option value="">직급선택</option>
                <option value="02">차장</option>
                <option value="03">과장</option>
                <option value="04">대리</option>
                <option value="05">주임</option>
                <option value="06">기사</option>
              </select>
              <select v-model="employee.sState">
                <option value="파견온직원">파견온직원</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="hc-popup-footer">
        <button @click="saveData" class="btn-save">저장</button>
        <button @click="closePopup" class="btn-close">닫기</button>
      </div>
      <div class="memo-section">
        <pre>
※ 근무관리 작성 방법

- 매장에 소속되 있는 모든 인원(사업주,파견 가거나 온 직원,휴무)을 입력
  해야 합니다.

- 퇴사 또는 삭제를 해야할 직원은 이름을 빈칸으로 두거나 다른직원으로 
   덮어씌우고 저장하시면 됩니다.
        </pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HcListPopPage",
  props: {
    shopData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        employees: [],
      },
    };
  },
  computed: {
    owner() {
      // lColNo가 1인 사업주 데이터를 찾습니다.
      return this.formData.employees.find((e) => e.lColNo === 1);
    },
    staff() {
      // lColNo가 1 초과 9 미만인 직원 데이터를 필터링합니다.
      return this.formData.employees.filter(
        (e) => e.lColNo > 1 && e.lColNo < 9
      );
    },
    dispatchedStaff() {
      // lColNo가 8 초과인 파견직원 데이터를 필터링합니다.
      return this.formData.employees.filter((e) => e.lColNo > 8);
    },
  },
  methods: {
    closePopup() {
      this.$emit("close", false); // 저장하지 않고 닫을 때는 false 전달
    },
    async saveData() {
      // 유효성 검사
      for (const emp of this.formData.employees) {
        if (emp.sName && emp.sName.trim() !== "") { // 이름이 있는 경우에만 검사
          if (!emp.sPosition) {
            alert(`'${emp.sName}'의 직급을 선택해 주세요.`);
            return;
          }
          if (!emp.sState) {
            alert(`'${emp.sName}'의 근무상태를 선택해 주세요.`);
            return;
          }
        }
      }

      // 저장할 데이터만 필터링 (완전히 비어있는 행은 제외)
      const dataToSave = this.formData.employees.filter(
        emp => emp.sName || emp.sPosition || emp.sState
      );

      if (dataToSave.length === 0) {
        alert("저장할 내용이 없습니다.");
        return;
      }

      try {
        await axios.post("/api/hcListPage/saveEmployees", {
          shopCd: this.shopData.SHOP_CD,
          employees: this.formData.employees, // 모든 행을 보내서 이름이 없는 경우 삭제 처리
        });
        alert("저장을 완료했습니다.");
        this.$emit("close", true); // 저장이 완료되면 true 전달하여 부모 컴포넌트가 그리드를 새로고침하도록 함
      } catch (error) {
        console.error("데이터 저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },
  },
  mounted() {
    // 팝업이 열릴 때 '수정' 모드이면 기존 데이터를 폼에 채웁니다.
    const employees = this.shopData?.employees
      ? JSON.parse(JSON.stringify(this.shopData.employees))
      : [];

    // --- 사업주(owner) 데이터가 없으면 빈 칸으로 채웁니다. ---
    if (!employees.some((e) => e.lColNo === 1)) {
      employees.unshift({ lColNo: 1, sName: "", sPosition: "사업주", sState: "" });
    }

    // --- 직원(staff) 데이터가 7개 미만이면 빈 칸으로 채웁니다. ---
    const staffCount = employees.filter(
      (e) => e.lColNo > 1 && e.lColNo < 9
    ).length;
    const staffToAdd = 7 - staffCount;
    if (staffToAdd > 0) {
      // staff의 lColNo는 2부터 8까지입니다.
      const existingStaffColNos = new Set(employees.map((e) => e.lColNo));
      for (let i = 2; i <= 8; i++) {
        if (employees.length >= 8) break; // 사업주 포함 최대 8명
        if (!existingStaffColNos.has(i)) {
          employees.push({ lColNo: i, sName: "", sPosition: "" });
        }
      }
    }

    // --- 파견직원(dispatchedStaff) 데이터가 2개 미만이면 빈 칸으로 채웁니다. ---
    const dispatchedCount = employees.filter((e) => e.lColNo > 8).length;
    const dispatchedToAdd = 2 - dispatchedCount;
    if (dispatchedToAdd > 0) {
      // 파견직원의 lColNo는 9부터 10까지입니다.
      const existingDispatchedColNos = new Set(employees.map((e) => e.lColNo));
      for (let i = 9; i <= 10; i++) {
        if (employees.filter((e) => e.lColNo > 8).length >= 2) break;
        if (!existingDispatchedColNos.has(i)) {
          employees.push({ lColNo: i, sName: "", sPosition: "" });
        }
      }
    }

    this.formData.employees = employees;
  },
};
</script>

<style scoped>
.hc-popup-overlay {
  font-family: "Malgun Gothic", Arial, sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.hc-popup-content {
  background: white;
  padding: 10px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.hc-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #a0a0a0;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.hc-popup-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.btn-close-header {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.popup-body {
  margin-bottom: 5px;
}

.popup-body p {
  margin: 5px 0;
}

.form-section {
  margin-top: 5px;
}

.form-grid {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 5px;
}

.section-title {
  text-align: center;
  margin-top: 8px;
  margin-bottom: 5px;
}

.input-row-header {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
}

.owner-header {
  background-color: #ffc0c0; 
}

.staff-header {
  background-color: #c0c0ff;
}

.dispatched-header {
  background-color: #ffe0c0;
}

.name-header,
.position-header,
.status-header {
  text-align: center;
  border: 1px solid #a0a0a0;
}

.input-row {
  display: flex;
  align-items: center;
  border: 1px solid #eee;
}

.row-number {
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}

.name-input {
  flex-grow: 1;
}

.input-row input,
.input-row select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  margin: 0 1px;
}

.input-row .name-input {
  flex-basis: 80px;
  text-align: center;
}

.input-row select {
  flex-basis: 80px;
  text-align: center;
}

.row-number-header, .row-number { width: 30px; flex-shrink: 0; }
.name-header, .input-row .name-input { flex: 1; }
.position-header, .input-row select:nth-of-type(1) { flex: 1; }
.status-header, .input-row select:nth-of-type(2) { flex: 1; }

.memo-section {
  margin-top: 3px;
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.memo-section pre {
  white-space: pre-wrap; /* 줄바꿈을 위해 pre-wrap 사용 */
  font-family: "Malgun Gothic", Arial, sans-serif;
  font-size: 0.8rem;
  margin: 0;
}

.input-row textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

.hc-popup-footer {
  display: flex;
  margin-top: 5px;
  gap: 5px;
}

.btn-save,
.btn-close {
  flex: 1;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.btn-save {
  background-color: #4caf50;
  color: white;
}

.btn-close {
  background-color: #9e9e9e;
  color: white;
}
</style>
